import {
  ChangeDetectorRef,
  Component,
  Inject,
  effect,
  inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { GetResendCalculationDto, SendTypes } from 'src/app/core/api/models';
import { AppStateService } from 'src/app/core/services/app-state.service';

@Component({
  selector: 'app-resend-calculation',
  templateUrl: './resend-calculation.component.html',
  styles: [
    `
      .list-group-bg {
        @apply even:dark:tw-bg-dark-400 even:tw-bg-gray-100 odd:dark:tw-bg-dark-100 odd:tw-bg-white;
      }
      .value {
        font-weight: 500;
        font-size: 1.1rem;
      }
    `,
  ],
  standalone: false,
})
export class ResendCalculationComponent {
  appStateService = inject(AppStateService);
  pageVocabs = 'pages.sendQueue.fields.';

  model: GetResendCalculationDto;
  sendType?: SendTypes;
  get SendTypes() {
    return SendTypes;
  }
  mciImage: string;
  rightelImage: string;

  constructor(
    private dialogRef: MatDialogRef<ResendCalculationComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.model = data?.model;
    this.sendType = data?.sendType;
    effect(() => {
      this.mciImage =
        this.appStateService.currentThemeMode() == 'dark'
          ? '/assets/media/svg/operator/mci-dark.svg'
          : '/assets/media/svg/operator/mci.svg';
      this.rightelImage =
        this.appStateService.currentThemeMode() == 'dark'
          ? '/assets/media/svg/operator/rightel-dark.svg'
          : '/assets/media/svg/operator/rightel.svg';
    });
  }
  ngOnInit() {}

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onClose() {
    this.dialogRef.close(false);
  }

  onSubmit() {
    this.dialogRef.close(true);
  }
}
